module.exports = __webpack_public_path__ + "static/media/mc_controls.55b79a52.svg";